/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';
import styles from './alert.less';

export interface AlertProps {
  displayType: 'info' | 'confirm' | 'warning' | 'error' | 'neutral';
  area: string;
  name: string;
  msTimeout?: number;
}

const Alert: React.FunctionComponent<AlertProps> = ({
  displayType,
  children,
}) => {
  return (
    <div
      className={classNames(styles.appAlertItem, styles[displayType])}
      role="alert"
    >
      {children}
    </div>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ./app/gamma/src/components/alert/alert.tsx